import { useCallback } from 'react';

import { ModalCustomTemplate } from 'modules/modals/constants';
import { UseHandleApproveEvent } from './types';

const useHandleApproveEvent: UseHandleApproveEvent = ({
  approved,
  enabled,
  eventId,
  isSending,
  showModalCustom,
}) => {
  const handleApproveEvent = useCallback(() => {
    if (approved === null && !isSending && showModalCustom)
      showModalCustom({
        template: ModalCustomTemplate.APPROVE_EVENT,
        payload: { approved: true, eventId },
      });
  }, [approved, eventId, isSending, showModalCustom]);

  return enabled ? handleApproveEvent : undefined;
};

export default useHandleApproveEvent;
